import React from 'react';
import _ from 'lodash';
import {Row,Col} from 'react-bootstrap'
import { Link } from 'react-router-dom'
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import MdCameraAlt from 'react-icons/lib/md/camera-alt'
import FlatButton from 'material-ui/FlatButton';
import MdDelete from 'react-icons/lib/md/delete'
import MdEdit from 'react-icons/lib/md/edit'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from '../../Actions/index.js';
import env from '../../config/env.js'
import Dialog from 'material-ui/Dialog';
import moment from 'moment';

const apiUrl=env.apiUrl;
class CompanyEdit extends React.Component{
	constructor(props){
		super(props);
		this.state = {
	    	file: '',
	    	imagePreviewUrl: '',
	    	companyName: '',
	    	cityReq: '',
	    	stateReq: '',
	    	countryReq: '',
	    	accountEmailRequired: '',
	    	addressline1: '',
	    	addressline2: '',
	    	city: '',
	    	state: '',
	    	postcode: '',
	    	country: '',
	    	changeName: false,
	    	changeAddress1: false,
	    	changeAddress2: false,
	    	changeCity: false,
	    	changePostal: false,
	    	changeCountry: false,
	    	changeState: false,
	    	modalIsOpen: false,
	    	changeAccountDetail: '',
	    	changeAccountEmail: false,
			modalForceReAuthorise: {
				isOpen : false,
				requesting : false,
			}
	    };

	    this.onSubmitCompanyEdit=this.onSubmitCompanyEdit.bind(this);
	    this.changeName= this.changeName.bind(this);
	    this.changeAddress1= this.changeAddress1.bind(this);
	    this.changeAddress2= this.changeAddress2.bind(this);
	    this.changeCity= this.changeCity.bind(this);
	    this.changePostal= this.changePostal.bind(this);
	    this.changeState= this.changeState.bind(this);
		this.changeCountry= this.changeCountry.bind(this);
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.cancelDokkit = this.cancelDokkit.bind(this);
		this.changePlan = this.changePlan.bind(this);
	}
	openModal() {
	    this.setState({modalIsOpen: true});
	}
	closeModal() {
	    this.setState({modalIsOpen: false});
	}
	componentDidMount(){
		this.props.fetchAllSubscriptions();
		this.props.fetchLoginUserDetail();
	}
	_handleSubmit(e) {
	    e.preventDefault();
	}

	_handleImageChange(e) {
	    e.preventDefault();
	    let reader = new FileReader();
	    let file = e.target.files[0];
	    reader.onloadend = () => {
	      this.setState({
	        file: file,
	        imagePreviewUrl: reader.result
	      });
	    }
	    reader.readAsDataURL(file)
	}
	changeName(e){
		this.setState({companyName:e.target.value,changeName: true});
	}
	changeAddress1(e){
		this.setState({addressline1:e.target.value,changeAddress1: true});
	}
	changeAddress2(e){
		this.setState({addressline2:e.target.value,changeAddress2: true});
	}
	changeCity(e){
		this.setState({city:e.target.value,changeCity: true});
	}
	changeState(e){
		this.setState({state:e.target.value,changeState: true});
	}
	changeCountry(e){
		this.setState({country:e.target.value,changeCountry: true});
	}
	changePostal(e){
		this.setState({postcode:e.target.value,changePostal: true});
	}
	changeAccountEmail=(e)=>{
		this.setState({changeAccountDetail: e.target.value, changeAccountEmail: true})
	}

	componentWillReceiveProps(newProps) {
		const userDetail = newProps.currentuser;
	    const subscriptions = newProps.subscriptionPlan;

		if(newProps.company.companyUpdate && newProps.company.companyUpdate!==''){
			this.props.fetchLoginUserDetail();
			this.props.unsetCompanyeditFlag();
		}
	}
	//submit company edit form
	onSubmitCompanyEdit(e){

		e.preventDefault();
		var compname= document.companyEdit.companyName.value;
		var address1= document.companyEdit.addressline1.value;
		var address2= document.companyEdit.addressline2.value;
		var city= document.companyEdit.city.value;
		var postcode= document.companyEdit.postcode.value;
		var companyId= document.companyEdit.companyid.value;
		var state= document.companyEdit.state.value;
		var country= document.companyEdit.country.value;
		var stripeEmail = document.companyEdit.billingEmail.value;
		var customer_email = this.props.currentuser.currentUser? this.props.currentuser.currentUser.email: '';
		var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if(stripeEmail===''){
			this.setState({accountEmailRequired: 'Account email is required field.'});
			return false;
		}else if(!emailRegex.test(stripeEmail)){
			this.setState({accountEmailRequired: 'Please enter valid email'});
			return false;
		}
		else{
			this.setState({accountEmailRequired: ''});
		}
		var form = document.getElementById("companyEdit");
  		var formData = new FormData(form);
		var address={'addressline1':address1,'addressline2':address2,'city':city,'state':state,'country':country,'postcode':postcode };
		this.props.submitComponyEdit(formData,companyId,compname,address, stripeEmail, customer_email );

	}
	cancelDokkit(){
		let userId= this.props.currentuser.currentUser._id;
		this.props.cancelDokkit(userId);
		this.props.history.push(`/unsubscribe`, {userId});
	}
	changePlan(){
		this.props.history.push(`/subscription-plan`);
	}

	_openForceAuthoriseModal = () => {
		this.setState({
			modalForceReAuthorise : {...this.state.modalForceReAuthorise, isOpen: true}
		})
	}

	_closeForceAuthoriseModal = () => {
		this.setState({
			modalForceReAuthorise : {...this.state.modalForceReAuthorise, isOpen: false}
		})
	}

	_doForceAuthorise = () => {
		const {currentuser:{company}} = this.props
		if(company && company.simpro_url){
			this.setState({
				modalForceReAuthorise : {...this.state.modalForceReAuthorise, requesting: true}
			}, () => {

				let url = company.simpro_url || ""
				let simprouser = company.simprouser  || ""
				let simpropass = company.simpropass || ""
				let companyId = company._id || ""

				this.props.authorizeApi(companyId, url, simprouser, simpropass, false, `company`);
			})
		}else{
			alert("Invalid sympro details")
		}
		
	}

	render(){
		let companyId =  this.props.currentuser.currentUser ? this.props.currentuser.company._id : '';
		let compName = this.props.currentuser.company ? this.props.currentuser.company.name : '';
		let address = this.props.currentuser.companydetail ? this.props.currentuser.companydetail.address : '';
		let profile_image = (localStorage.getItem('profile_pic') !== 'null' && localStorage.getItem('profile_pic')) ? localStorage.getItem('profile_pic') : '/images/user.png';
        let {imagePreviewUrl} = this.state;
        let $imagePreview = null;
        var path=env.apiUrl;

        if (imagePreviewUrl) {
          $imagePreview = (<img src={imagePreviewUrl} alt="user" />);
        } else {
        	var check=this.props.currentuser.companydetail && this.props.currentuser.companydetail.logo && this.props.currentuser.companydetail.logo!=='';
        	if(check){
          		$imagePreview = (<img src={this.props.currentuser.companydetail.logo.location} alt="user" />);
        	}else{
          		$imagePreview = (<img src={profile_image} alt="user" />);
        	}
        }
        let subscription = this.props.subscriptionPlan.plans.subscription;
        let selectedPlanId=this.props.currentuser.subsuser?this.props.currentuser.subsuser.subscription_id: '';
        var selectedSubs=[],subscriptionStyle;
        if(selectedPlanId){
        	selectedSubs= _.filter(subscription,{_id: selectedPlanId});
	        subscriptionStyle;

	        if(selectedSubs[0]){
	        	if(selectedSubs[0].duration_type=='MONTHLY'){
	        		subscriptionStyle={
	        			color: '#93ca21'
	        		}
	        	}else{
	        		subscriptionStyle={
	        			color: '#e2a62c'
	        		}
	        	}
	        }
		}
        let subs_created_date = this.props.currentuser.companydetail ? this.props.currentuser.companydetail.subs_created_date : null;
		let subs_end_date = this.props.currentuser.companydetail ? this.props.currentuser.companydetail.subs_end_date : null;
		let subs_amount = this.props.currentuser.companydetail ? this.props.currentuser.companydetail.subs_amount : 0;
	    let subs_allowance = this.props.currentuser.companydetail ? this.props.currentuser.companydetail.subs_allowance : 0;
	    let userEmail = this.props.currentuser.currentUser ? this.props.currentuser.currentUser.email : '';

	    let stripe_email = this.props.currentuser.companydetail ? this.props.currentuser.companydetail.stripe_email : '';
		let checkalert = this.props.subscriptionPlan.free_trial_end;
		let plan =this.props.subscriptionPlan.plans.subscription;
		var timeDiff = Math.abs(new Date(subs_end_date).getTime() - new Date(subs_created_date).getTime());
      	var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
	    var trial_period_days;
	    if(plan){
			trial_period_days = diffDays
	    	// trial_period_days=plan[0].trial_period_days;
		}
	    let startDate = moment(subs_created_date).add('days', trial_period_days);
	    let timeEnd = moment(new Date());
	    let diff = startDate.diff(timeEnd);
	    let diffDuration = moment.duration(diff);
		let days= diffDuration.days();
		let months = diffDuration.months() > 0 ? diffDuration.months() + ' month ' : '';       
        const action = [
          <FlatButton 
			    label="Cancel Dokkit" 
			    secondary={true} 
			    className={'cancel-dokkit-button'}
			    icon={<MdDelete color="#e94731" />}
			    labelStyle={{'fontWeight': '600' , color: '#e94731'}}
			    style={{float:'left'}}
			    onClick={this.cancelDokkit}
			/>,
          <RaisedButton
            label="Change Plan"
            primary={true}
            className={'cancel-dokkit-button'}
            labelStyle={{'color': '#fff'}}
            keyboardFocused={true}
            onClick={this.changePlan}
          />,

        ];

        const {currentuser:{company}} = this.props
        const btnForceReauthorise = (
        	<React.Fragment>
				<RaisedButton
					label="Re-Authorise"
					type="button"
					labelColor="#fff"
					fullWidth={false}
					onClick={this._openForceAuthoriseModal}
				/>

				<Dialog
		          	title={`Are you sure you want to reauthorise forcefully?`}
		          	actions={[
		          		<FlatButton
					        label="Cancel"
					        primary={true}
					        onClick={this._closeForceAuthoriseModal}
					        keyboardFocused={true}
					        disabled={this.state.modalForceReAuthorise.requesting}
				      	/>,
				      	<RaisedButton
					        label={this.state.modalForceReAuthorise.requesting ? "Please! wait while processing..." : "Re-Authorise"}
							labelStyle={{ 'color': '#fff' }}
					        primary={true}
					        onClick={(e) => {
					        	e.stopPropagation()
					        	this._doForceAuthorise()
					        }}
					        disabled={this.state.modalForceReAuthorise.requesting}
				      	/>
		          	]}
		          	modal={true}
		          	open={this.state.modalForceReAuthorise.isOpen}
		        >
		         	<table>
		         		<tbody>
		         			<tr>
								<td width="50%">simPRO build</td>
								<td width="50%">
									{company ? company.simpro_url : "N/A"}
									</td>
							</tr>
		         		</tbody>
		         	</table>
		        </Dialog>
			</React.Fragment>
        )

		return(
		<div className="change-password-content">
			<Row>
				<form name="companyEdit" id="companyEdit" onSubmit={this.onSubmitCompanyEdit} encType="multipart/form-data">
				<Col md={4}>
					<div className="profile-pic-section">
						<figure>
							{$imagePreview}
							<div className="upload-img-sec">
								<input type="file" id="profile-image" name="company_image" className="file-uploads" 
                                        onChange={(e)=>this._handleImageChange(e)} accept="image/*" />
                                 <label htmlFor="profile-image">
                                 	<MdCameraAlt  />  
                                 </label>	     
                            </div>            
						</figure>
						<h3>{compName}</h3>
					</div>
				</Col>
				<Col md={8}>
					<div className="chenge-password-form">
						<div className="heading-sec">
							<h3>Company Info</h3>
						</div>
						 
                             <Row>
                                <Col md={12}>
                                    <TextField
                                        fullWidth={ true }
                                        floatingLabelText="Name"
                                        type="text"
                                        name="companyName"
                                        value={compName && !this.state.companyName? compName: this.state.companyName}
                                        onChange={this.changeName}
                                        disabled={true}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                     <TextField
                                        fullWidth={ true }
                                        floatingLabelText="Address Line 1"
                                        type="text"
                                        name="addressline1"
                                        value={address && !this.state.changeAddress1?address.addressline1 : this.state.addressline1}
                                        onChange={this.changeAddress1}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}  >
                                    <TextField
                                        fullWidth={ true }
                                        floatingLabelText="Address Line 2"
                                        type="text"
                                        name="addressline2"
                                        value={address && !this.state.changeAddress2?address.addressline2 : this.state.addressline2}
                                        onChange={this.changeAddress2}
                                    />
                                </Col>
                            </Row>
                             <Row>
                                <Col md={6} >
                                    <TextField
                                        fullWidth={ true }
                                        floatingLabelText="City"
                                        type="text"
                                        name="city"
                                        value={address && !this.state.changeCity?address.city : this.state.city}
                                        onChange={this.changeCity}
                                        errorText={this.state.cityReq}
                                    />
                                </Col>
                                 <Col md={6} >
                                    <TextField
                                     fullWidth={ true }
							          floatingLabelText="County"
							          name="state"
							          type="text"
							          value={address && !this.state.changeState?address.state : this.state.state}
							          onChange={this.changeState}
							          errorText={this.state.stateReq}
							         />
                                </Col>
                            </Row>
                            <Row>
                                 <Col md={6} >
                                    <TextField
                                     fullWidth={ true }
							          floatingLabelText="Country"
							          value={address && !this.state.changeCountry?address.country : this.state.country}
							          onChange={this.changeCountry}
							          name="country"
							          type="text"
							          errorText={this.state.countryReq}
							         />
                                </Col>
                                <Col md={6} className="margb20px" >
                                    <TextField
                                        fullWidth={ true }
                                        floatingLabelText="Postcode"
                                        type="text"
                                        name="postcode"
                                        value={address && !this.state.changePostal?address.postcode : this.state.postcode}
                                        onChange={this.changePostal}
                                    />
                                </Col>
                            </Row>
                           
                            <Row className="margb20px">
                            	<Col md={12}>
                            		<div className="audio-visual-list organisation-account-detail">
                            			<div className="spacer"></div>
                            			<div className="heading-sec">
											<h3>Account Details</h3>
										</div>
										<ul>
											<li>
											   <Row className="display-flex-align margin-bottom-15px">
											   <Col xs={6}>
											   		<p>Account Email</p>
											   	</Col>
											   	<Col xs={6}>
													<TextField
														fullWidth={ true }
														type="email"
														name="billingEmail"
														value={!this.state.changeAccountEmail? typeof(stripe_email) === 'undefined' ? userEmail: stripe_email : this.state.changeAccountDetail}
														errorText={this.state.accountEmailRequired}
														onChange={this.changeAccountEmail}
													/>
											   	</Col>
											   	</Row>
											   	<Row className="margin-bottom-15px">
											   	<Col xs={6}>
											   		<p>
											   			Subscription 
 														
											   		</p>

											   	</Col>
											   	<Col xs={6}>
											   		<p>
											   			<Link style={subscriptionStyle} className="standard-plan" to="/subscription-plan">{selectedSubs[0]?selectedSubs[0].label:''}<MdEdit /></Link>
											   		</p>
											   	</Col>
											   </Row>

											   <Row>
											   	<Col xs={6}>
											   		<p>Allowance left </p>
											   	</Col>
											   	<Col xs={6}>
											   		<p>
											   			{subs_allowance}
											   		</p>
											   	</Col>
											   </Row>

											</li>
											<li>
											   <Row>
											   	<Col xs={6}>
											   		<p>Billing Plan </p>
											   	</Col>
											   	<Col xs={6}>
											   		<p>
											   			<Link to="#">{_.toLower(selectedSubs[0]?selectedSubs[0].duration_type:'Yearly')} </Link>
											   		</p>
											   	</Col>
											   </Row>
											</li>
											<li>
											   <React.Fragment>
						                            <Row  className="margb20px">
						                            	<Col xs={6}>
													   		<p>Re-Authorise</p>
													   	</Col>
						                            	<Col xs={6}>
													   		{btnForceReauthorise}
													   	</Col>
						                            </Row>

						                            <Row  className="margb20px">
						                            	<Col xs={12}>
													   		<span className="text-danger">
													   			{/*Note: Please re-authorise your account if you have updated your simPRO password.<br/>
													   			Once you re-authorise we will be able to fetch your job details.*/}
													   			Note: Only click re-authorise if you are receiving error messages when importing a job or have been advised by support to do so.
													   		</span>
													   	</Col>
						                            </Row>
					                            </React.Fragment>
											</li>
										</ul>
									</div>
                            	</Col>
                            </Row>
                            

                            {!checkalert && subs_amount==null?
                            <Row  className="margb20px">
                            	<Col md={12}>
                            		<div className="alert alert-danger" role="alert">
										  Your Dokkit subscription starts in {months} {days} days unless you cancel.
									</div>
                            	</Col>
                            </Row>
                            : null }
                            <Row className="display-flex">
                                <Col md={6}>
								    <FlatButton 
									    label="Cancel Dokkit" 
									    secondary={true} 
									    icon={<MdDelete color="#e94731" />}
									    labelStyle={{'fontWeight': '600' , color: '#e94731'}}
									    onClick={this.openModal}
									/>
                                </Col>
                                <Col md={6}>
                                  <div className="forgotten-password text-right">
                                  	<input type="hidden" value={companyId} name="companyid"/>
                                   	<RaisedButton 
                                   		label="Update" 
                                   		type="submit"
                                   		labelColor="#fff" 
                                   		labelStyle={{'fontWeight': '600'}}
                                   		fullWidth={false} 
                                   	/>
                                  </div>
                                </Col>
                            </Row>
                         
						</div>
					</Col>
				</form>
				{ this.state.modalIsOpen? 
				<Dialog 
	                  actions={action}
	                  className="model-support"
	                  modal={false}
	                  contentClassName="model-top-overlay no-overlay"
	                  open={ this.state.modalIsOpen}
	                  onRequestClose={this.closeModal}
	                > 
	                <div style={{float: 'right',padding: '5px',margin: '-16px'}} onClick={this.closeModal} > <img src="/images/cross.svg"  alt="logo" /></div>
		         	<div className="other-popup-content learn-more-popup">
		         	  <div style={{'textAlign':'left'}}>
				          <h3>Cancel Dokkit</h3>
				          <p>
				          	If you cancel your subscription all jobs and O&M Manuals will be deleted.
				          </p>
			          </div>
			       </div>
	    		</Dialog>
	    		: null }
			</Row>
		</div>
		)
	}
}
const mapStateToProps= (state,props)=> {
    return {
      currentuser : state.login,
      company : state.company,
      subscriptionPlan: state.subscription,
    };
}
export default withRouter(connect(mapStateToProps,actions)(CompanyEdit));



// <TextField
// fullWidth={ true }
// floatingLabelText="Account email"
// type="email"
// name="billingEmail"
// value={!this.state.changeAccountEmail? typeof(stripe_email) === 'undefined' ? userEmail: stripe_email : this.state.changeAccountDetail}
// errorText={this.state.accountEmailRequired}
// onChange={this.changeAccountEmail}
// />


// WEBPACK FOOTER //
// ./src/Components/Pages/CompanyEdit.js